import { apiClient } from '@/services/ApiClient.js'

export default {
  getQuotations(query) {
    return apiClient
      .get('tarfin-pro-quotations', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuotation(id) {
    return apiClient
      .get('tarfin-pro-quotations/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createQuotation(quotation) {
    return apiClient
      .post('tarfin-pro-quotations', quotation)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateQuotation(id, quotation) {
    return apiClient
      .patch('tarfin-pro-quotations/' + id, quotation)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteQuotation(id) {
    return apiClient
      .delete('tarfin-pro-quotations/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendQuotationToRetailer(quotation) {
    return apiClient
      .post('tarfin-pro-quotations/send-quotation', { payload: quotation })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendAllocationStatus(id, status) {
    return apiClient
      .patch('tarfin-pro-quotations/' + id + '/toggle-decision-confirmation', {
        status
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelQuotation(id, rejection_reason) {
    return apiClient
      .post('tarfin-pro-quotations/' + id + '/cancel-quotation', {
        rejection_reason
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailersForQuotation(regionId) {
    return apiClient
      .get('retailers/filtered-for-quotation', { params: { region_id: regionId } })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportQuotations(query) {
    return apiClient
      .get('tarfin-pro-quotations/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  approveSignedPromissory(quotationId) {
    return apiClient
      .patch(`tarfin-pro-quotations/${quotationId}/approve-signed-promissory-note`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  destroyPromissoryNote(documentId) {
    return apiClient
      .delete(`tarfin-pro-quotations/destroy-promissory-note/` + documentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendPaymentSMS(quotationId) {
    return apiClient
      .post(`tarfin-pro-quotations/${quotationId}/send-reminder-sms`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuotationCollection(quotationId) {
    return apiClient
      .get(`tarfin-pro-quotations/${quotationId}/collections`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteQuotationCollection(params) {
    return apiClient
      .delete(`tarfin-pro-quotations/${params.quotationId}/collections/ ${params.collectionId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createQuotationCollection(quotationId, collection) {
    return apiClient
      .post(`tarfin-pro-quotations/${quotationId}/collections`, { ...collection })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  generateMaturityDays(query) {
    return apiClient
      .post(`tarfin-pro-quotations/generate-maturity-days`, query)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
